import { createSelector } from 'reselect'

const emptyRecommendation: App.OfferBasedGraphRecommendation = {
  offerIds: [],
  state: 'loading',
  filterKey: '',
}

export const getGraphRecommendations = createSelector(
  (state: App.State, offerId?: string) => state.recommendations.recommendations[offerId ?? ''],
  (recommendation): App.OfferBasedGraphRecommendation => recommendation ?? emptyRecommendation,
)
